export default () => ({
  isLoading: false,
  isLoaded: false,
  error: null,

  cardSlot: null,
  coupons: [],
})
